// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: false,
        activeFilterScrollbar: 'browser'
    }
};

/* ==========================================================================
   RK Creative Solutions, september 2026
   Beschikbare maten op de collectiekaart.

   Werkt alleen voor de maat-optie, niet voor kleur, zodat accessoires
   met alleen een kleurvariant geen lege rij krijgen. Uitverkochte maten
   blijven staan als doorgestreept hokje. Levert Boost ook het aantal
   per maat, dan kleuren de laatste stuks bruin, anders valt dat weg.

   Wil je dit uitzetten, zet RK_SIZES_ON op false.
   ========================================================================== */
var RK_SIZES_ON = true;
var RK_LOW_STOCK = 3;

(function rkInjectSizeStyles() {
    if (!RK_SIZES_ON) return;
    var css = ''
        + '.rk-csizes{display:flex;flex-wrap:wrap;gap:4px;margin:8px 0 0;padding:0;list-style:none}'
        + '.rk-csizes li{font-family:"IBM Plex Mono",ui-monospace,SFMono-Regular,Menlo,monospace;'
        + 'font-size:10px;letter-spacing:.04em;line-height:1.5;border:1px solid #cbc8c0;'
        + 'padding:2px 6px;min-width:42px;text-align:center;color:#17171b}'
        + '.rk-csizes li.rk-csize--off{border-style:dashed;color:#6f6d66;text-decoration:line-through;opacity:.55}'
        + '.rk-csizes li.rk-csize--low{border-color:#8a5a1f;color:#8a5a1f}'
        + '@media (max-width:640px){.rk-csizes li{font-size:9px;min-width:36px;padding:2px 4px}}';
    var tag = document.createElement('style');
    tag.setAttribute('data-rk-sizes', '');
    tag.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(tag);
})();

// Bouw de matenrij voor een product uit de Boost data
function rkBuildSizes(data) {
    if (!RK_SIZES_ON) return '';
    if (!data || !data.variants || !data.options_with_values) return '';

    // Zoek welke optie de maat is. Alleen die tonen we.
    var sizeIndex = -1;
    for (var o = 0; o < data.options_with_values.length; o++) {
        var optName = (data.options_with_values[o].name || '').toLowerCase();
        if (optName.indexOf('maat') > -1 || optName.indexOf('size') > -1 || optName.indexOf('taille') > -1) {
            sizeIndex = o;
            break;
        }
    }
    if (sizeIndex === -1) return '';

    var seen = {};
    var items = [];
    for (var v = 0; v < data.variants.length; v++) {
        var variant = data.variants[v];
        var label = variant['option' + (sizeIndex + 1)];
        if (!label) continue;
        label = String(label).trim();
        if (label === '' || label.toLowerCase() === 'default title') continue;
        if (seen[label]) continue;
        seen[label] = true;

        var cls = '';
        if (!variant.available) {
            cls = ' class="rk-csize--off"';
        } else {
            var qty = variant.inventory_quantity;
            if (typeof qty === 'number' && qty > 0 && qty <= RK_LOW_STOCK) {
                cls = ' class="rk-csize--low"';
            }
        }
        items.push('<li' + cls + '>' + label + '</li>');
    }

    if (items.length === 0) return '';
    return '<ul class="rk-csizes">' + items.join('') + '</ul>';
}

// Declare Templates
var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml':  '<article class="product--root" {{dataHoverImage}}>' +
                                '{{itemWishlist}}' +
                                '{{itemLabels}}' +
                                '<a href="{{itemUrl}}">' +
                                    '<div class="product--image-wrapper">' +
                                        '<div class="product--image">' +
                                            '{{itemImage}}' +
                                        '</div>' +
                                        '{{itemHoverImage}}' +
                                    '</div>' +
                                '</a>' +
                                '<div class="product--details">' +
                                    '<a href="{{itemUrl}}">' +
                                        '<div class="product--title">{{itemTitle}}</div>' +
                                    '</a>' +
                                    '{{itemVendor}}' +
                                    '<a href="{{itemUrl}}">' +
                                        '<div class="product--price-wrapper">' +
                                            '{{itemPrice}}' +
                                        '</div>' +
                                    '</a>' +
                                    '{{itemSizes}}' +
                                '</div>' +
                            '</article>',
    // Pagination Template
    'previousActiveHtml': '<li class="arrow left"><a href="{{itemUrl}}"><span class="glyph arrow-left" aria-hidden="true"></span> '+ bcSfFilterConfig.label.pagination_previous +'</a></li>',
    'previousDisabledHtml': '<li class="arrow left unavailable"><a href=""><span class="glyph arrow-left" aria-hidden="true"></span> '+ bcSfFilterConfig.label.pagination_previous +'</a></li>',
    'nextActiveHtml': '<li class="arrow right"><a href="{{itemUrl}}">'+ bcSfFilterConfig.label.pagination_next +' <span class="glyph arrow-right" aria-hidden="true"></span></a></li>',
    'nextDisabledHtml': '<li class="arrow right unavailable"><a href="">'+ bcSfFilterConfig.label.pagination_next +' <span class="glyph arrow-right" aria-hidden="true"></span></a></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="current"><a href="">{{itemTitle}}</a></li>',
    'pageItemRemainHtml': '<li class="unavailable"><a href="">{{itemTitle}}</a></li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + '</label><select>{{sortingItems}}</select>',
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;


    // Add data hover image
    var dataHoverImage = bcSfFilterConfig.custom.hover_image_enable ? 'data-hover-image="true"' : '';
    itemHtml = itemHtml.replace(/{{dataHoverImage}}/g, dataHoverImage);

    // Add Labels
    var itemLabelsHtml = '';
    if (soldOut) {
        itemLabelsHtml += '<a href="{{itemUrl}}">';
        itemLabelsHtml += '<div class="product--sold-out"><span>';
        itemLabelsHtml += bcSfFilterConfig.label.sold_out;
        itemLabelsHtml += '</span></div>';
        itemLabelsHtml += '</a>';
    } else if (onSale) {
        itemLabelsHtml += '<a href="{{itemUrl}}">';
        itemLabelsHtml += '<div class="product--sale" href=""><span>';
        itemLabelsHtml += bcSfFilterConfig.label.sale;
        itemLabelsHtml += '</span></div>';
        itemLabelsHtml += '</a>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Image
    itemHtml = itemHtml.replace(/{{itemImage}}/g, buildItemImage(data, 'image'));

    // Add Vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.vendor_enable) {
        itemVendorHtml += '<p class="vendor"><a href="' + this.buildProductItemVendorUrl(data.vendor) + '">' + data.vendor + '</a>'
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale){
        itemPriceHtml += '<span class="product--compare-price">' +
                            '<span class="money">' + this.formatMoney(data.compare_at_price_min) + '</span>' +
                         '</span>' +
                         '<span class="product--price">' +
                            '<span class="money">' + this.formatMoney(data.price_min) + '</span>' +
                         '</span>';
    } else {
        if (priceVaries) {
            itemPriceHtml += '<span class="product--from">' + bcSfFilterConfig.label.from_price + ' </span>';
        }
        itemPriceHtml += '<span class="product--price"><span class="money">' + this.formatMoney(data.price_min) + '</span></span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Sizes, RK
    itemHtml = itemHtml.replace(/{{itemSizes}}/g, function() { return rkBuildSizes(data); });

    // Add Hover Image
    itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, buildItemImage(data, 'hover'));


    /* Swym integration */
    var itemWishlistHtml = '<button class="swym-button swym-add-to-wishlist-view-product product_{{itemId}}" data-with-epi="true" data-swaction="addToWishlist"  data-product-id="' + JSON.stringify(data.id) + '" data-variant-id="'+ JSON.stringify(data.variants[0].id) +'" data-product-url="'+ window.location.origin + data.url +'"></button>';
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage in pageArr) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};


// Build srcset
// @data = data.images_info
function getSrcsetUrl(data) {
    var arr = [];
    var listImageWidth = getListImageWidth(data);
    var len = listImageWidth.length;
    var url = '';

    if (data != null) {
        for (var i = 0; i < len; i++) {
            url = data.src.substring(0, data.src.lastIndexOf('.'));
            url += '_' + listImageWidth[i] + 'x';
            url += data.src.substring(data.src.lastIndexOf('.'));
            url += ' ' + listImageWidth[i] + 'w';
            arr.push(url);
        }
    }

    return arr;
}

// Get Aspect Ratio based on Dimensions
// @data = data.images_info
function getAspectRatio(data) {
    var width = (data == null) ? '600' : data.width;
    var height = (data == null) ? '400' : data.height;

    return width / height;
}

// Get Image Width List
// @data = data.images_info
function getListImageWidth(data) {
    var arr = [295, 394, 590, 700, 800, 1000, 1200, 1500, 1800, 2000, 2400];
    var arr_len = arr.length;
    var rs = [];

    if (data != null) {
        for (var i = 0; i < arr_len; i++) {
            var width_init = arr[i] + 0;

            if (data.width > width_init) {
                rs.push(width_init);
            }
        }
        rs.push(data.width);
    }

    return rs;
}

function buildItemImage(data, type) {
    var itemImage = '';
    var index = Object.keys(data.images);
    var imgWidth = (data.images_info[0] == null) ? '600' : data.images_info[0].width;

    // Calculate padding-top based on aspect ratio
    var pad_top = 1 / getAspectRatio(data.images_info[0]) * 100;

    // Image Section
    if (type !== 'image') {
        itemImage += '<div class="product--hover-image">';
    }

    itemImage += '<div class="image--root" data-aspectratio="' + getAspectRatio(data.images_info[0]) + '" style="width:' + imgWidth + 'px">';
    itemImage += '<div class="image--container" style="padding-top:' + pad_top + '%">';

    // Get image src (type='image') & hover image src
    if (type === 'image') {
        if (index.length > 0) {
            itemImage += '<img class="lazyload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0])
                        + ']" src="' + data.images[1]
                        + '" data-src="' + getSrcsetUrl(data.images_info[0])
                        + '" srcset="' + getSrcsetUrl(data.images_info[0])
                        + '" alt="' + data.title + '">';
        } else {
            itemImage += '<img class="lazyload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0])
                        + ']" src="' + bcSfFilterConfig.general.no_image_url
                        + '" data-src="' + getSrcsetUrl(data.images_info[0])
                        + '" srcset="' + getSrcsetUrl(data.images_info[0])
                        + '" alt="' + data.title + '">';
        }
    } else {
        if (index.length > 0) {
            itemImage += '<img class="lazypreload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0])
                        + ']" src="' + data.images[index.length]
                        + '" data-src="' + getSrcsetUrl(data.images_info[data.images_info.length - 1])
                        + '" srcset="' + getSrcsetUrl(data.images_info[data.images_info.length - 1])
                        + '" alt="' + data.title + '">';
        } else {
            itemImage += '<img class="lazyload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0])
                        + ']" src="' + bcSfFilterConfig.general.no_image_url
                        + '" data-src="' + getSrcsetUrl(data.images_info[data.images_info.length - 1])
                        + '" srcset="' + getSrcsetUrl(data.images_info[data.images_info.length - 1])
                        + '" alt="' + data.title + '">';
        }
    }

    if (type !== 'image') {
        itemImage += '</div>';
    }
    itemImage += '</div></div>';

    return itemImage;
}

// Build additional attributes of product items
BCSfFilter.prototype.buildExtrasProductList = function(data) {
    jQ(".product--image-wrapper").each(function() {
        jQ(this).on('mouseover mouseout', function() {
            var item = jQ(this).children('.product--hover-image');

            if (item.length > 0) {
                if (event.type == 'mouseover') {
                    jQ(item).attr('style', 'opacity: 1');
                } else {
                    jQ(item).attr('style', 'opacity: 0');
                }
            }
        });
    });
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  /** Start Swym integration **/
window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function(swat) {
    // Wrap with callback for loading without additional checks
    var products = [];
    data.products.forEach(function(product) {
        var image_src = getSrcsetUrl(product.images_info[0]);
        var productCopy = product;
        productCopy.featured_image = image_src;
        productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
        productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
        products.push(productCopy);
    });
    swat.mapShopifyProducts(products); // Product mapped data to swym layer
    swat.initializeActionButtons('#bc-sf-filter-products'); // Buttons can now be initialized
});
/** End Swym integration **/
};


// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; if(data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0){ data[k].tags = data[k]['original_tags'].slice(0); }} return data };

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
